module.exports = __webpack_public_path__ + "img/2f5ee3c.jpg";